module.exports = __webpack_public_path__ + "img/_Large-Horizontal-Rectangular-Attachment.100a1b07.jpg";